<script lang="ts">
export default {
  name: 'SearchKeywordImpressionLabels',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { KkBox, KkLoading, KkIcon } from 'src/biz_spa/components/base'
import { KkItemList } from 'src/biz_spa/domains/management/components'
import { useSearchKeywordImpressionLabels } from 'src/biz_spa/domains/management/composables'
import type { ItemListHeader } from 'src/biz_spa/domains/management/components/KkItemList/index.vue'

const { t } = useI18n()
const { labels, isLoading, readLabels, companyUuid } = useSearchKeywordImpressionLabels()

const header = computed<ItemListHeader[]>(() => {
  return [
    { key: 'title', title: t('pages.companies.searchKeywordImpressionLabels.header.title'), width: '34%' },
    { key: 'updatedAt', title: t('pages.companies.searchKeywordImpressionLabels.header.updatedAt'), width: '27%' },
    { key: 'keywords', title: t('pages.companies.searchKeywordImpressionLabels.header.keywords'), width: '19%' },
    { key: 'actions', width: '20%' },
  ]
})

readLabels()
</script>

<template>
  <KkBox :class="$style.container">
    <template #content>
      <KkLoading v-if="isLoading" />
      <KkItemList v-else :header="header" :items="labels">
        <template #item="{ item }">
          <td :data-label="`${t('pages.companies.searchKeywordImpressionLabels.header.title')}: `" class="u-fwB">
            {{ item.title }}
          </td>
          <td :data-label="`${t('pages.companies.searchKeywordImpressionLabels.header.updatedAt')}: `">
            {{ item.updatedAt?.format(t('format.datetime.default')) || '-' }}
          </td>
          <td :data-label="`${t('pages.companies.searchKeywordImpressionLabels.header.keywords')}: `">
            {{ item.keywords.length ? t('pages.companies.searchKeywordImpressionLabels.count', { count: item.keywords.length }) : t('pages.companies.searchKeywordImpressionLabels.unregistered') }}
          </td>
          <td class="u-taR">
            <router-link
              :to="{ name: 'CompaniesSearchKeywordImpressionLabelForm', params: { company_uuid: companyUuid, label_id: item.id } }"
              :class="$style.edit"
            >
              <span :class="$style.editIcon">
                <KkIcon name="edit" />
              </span>
              {{ t('pages.companies.searchKeywordImpressionLabels.edit') }}
            </router-link>
          </td>
        </template>
      </KkItemList>
    </template>
  </KkBox>
</template>

<style lang="scss" module>
.container {
  min-height: 528px;
}
.edit {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0 10px;
  font-size: 12px;
  text-decoration: none;
}
.editIcon {
  width: 16px;
}
</style>
